"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transition = void 0;
var styled_components_1 = require("styled-components");
/**
 * Generate a CSS transition property based on the input properties.
 *
 * @param {string[]} properties - The CSS properties to transition
 * @return {FlattenInterpolation<ThemedStyledProps<any, any>>} The generated CSS transition property
 */
var transition = function () {
    var properties = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        properties[_i] = arguments[_i];
    }
    return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    transition: ", ";\n  "], ["\n    transition: ", ";\n  "])), properties.map(function (property) {
        if (property.split(' ').length === 1) {
            // Meaning only property name is passed, e.g., background-color
            return "".concat(property, " 0.3s ease-out");
        }
        else if (property.split(' ').length === 2) {
            // Means duration is there...
            return "".concat(property, " ease-out");
        }
        else {
            // Else we assume time and ease and whatever is passed
            return property;
        }
    }).join(', '));
};
exports.transition = transition;
var templateObject_1;
